module.exports = __webpack_public_path__ + "img/topHappy.bc41fb57.png";